module.exports = "<sx-template-listado \r\n  [titulo]=\"'View Engines'\"\r\n  [listado]=\"viewsEngine\"> \r\n</sx-template-listado>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/viewengine/list.viewengine.component.html
// module id = ../../../../../src/app/private/viewengine/list.viewengine.component.html
// module chunks = main